import { render, staticRenderFns } from "./editHouses.vue?vue&type=template&id=677c7d06"
import script from "./editHouses.vue?vue&type=script&lang=js"
export * from "./editHouses.vue?vue&type=script&lang=js"
import style0 from "./editHouses.vue?vue&type=style&index=0&id=677c7d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports